import { Subscription_Add_Ons_Enum } from "generated/graphql";

export type CustomUpgradesStatus = "enabled" | "locked" | "hidden";

export const CUSTOM_UPGRADES_ADD_ON = Subscription_Add_Ons_Enum.CustomUpgrades;

// Shared copy for the locked (add-on missing) upsell — used for both the
// tooltip on disabled entry points and the message that replaces the upgrade
// picker in the scenario dialog.
export const CUSTOM_UPGRADES_LOCKED_MESSAGE =
    "Custom Upgrades is an Add-On Feature. Contact your Account Manager to learn more and get started.";

/**
 * Resolves how custom upgrades should render for a cluster from the three
 * independent gates:
 *  - `hidden`: the feature is off for this team or region — render nothing.
 *  - `locked`: the feature is available but the cluster's subscription hasn't
 *    unlocked the add-on — render the upsell (disabled controls + message).
 *  - `enabled`: fully unlocked — render the feature normally.
 */
export const customUpgradesStatus = ({
    regionEnabled,
    hasAddOn
}: {
    regionEnabled: boolean;
    hasAddOn: boolean;
}): CustomUpgradesStatus => {
    if (!regionEnabled) return "hidden";
    return hasAddOn ? "enabled" : "locked";
};
